var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.58 16.5a7.5 7.5 0 100-15 7.5 7.5 0 000 15z",
    fill: "#C4C9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.83 6.75l-4.5 4.5M7.33 6.75l4.5 4.5",
    stroke: "#FAFAFC",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOSAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkuNTc5ODMgMTYuNUMxMy43MjIgMTYuNSAxNy4wNzk4IDEzLjE0MjEgMTcuMDc5OCA5QzE3LjA3OTggNC44NTc4NiAxMy43MjIgMS41IDkuNTc5ODMgMS41QzUuNDM3NyAxLjUgMi4wNzk4MyA0Ljg1Nzg2IDIuMDc5ODMgOUMyLjA3OTgzIDEzLjE0MjEgNS40Mzc3IDE2LjUgOS41Nzk4MyAxNi41WiIgZmlsbD0iI0M0QzlEOSIvPgo8cGF0aCBkPSJNMTEuODI5OCA2Ljc1TDcuMzI5ODMgMTEuMjUiIHN0cm9rZT0iI0ZBRkFGQyIgc3Ryb2tlLXdpZHRoPSIxLjEyNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik03LjMyOTgzIDYuNzVMMTEuODI5OCAxMS4yNSIgc3Ryb2tlPSIjRkFGQUZDIiBzdHJva2Utd2lkdGg9IjEuMTI1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";
export { SvgCloseCircle as ReactComponent };